import React, { useEffect, useState } from "react";
import './Rutas.scss'
import TitleView from "../../../components/atoms/TitleView/TitleView";
import IconInput from "../../../components/atoms/IconInput/IconInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import searchIcon from '../../../assets/icons/search.svg'
import { addRuta, getAllOperadores, getBitacorasAEliminar, getClients, getEstructuras, getOperadores, getRutes, getTipoServicios, updateRuta } from "./RutasIntegracion";
import lapiz from '../../../assets/icons/lapiz.png'
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import { Dialog } from "primereact/dialog";
import InputText from "../../../components/atoms/InputText/InputText";
import Button from "../../../components/atoms/Button/Button";
import Swal from "sweetalert2";
import { transferisServiciosIntegracion } from "../../monitoreo/TransferirServicios/transferisServiciosIntegracion";
const Rutas = () => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [data, setData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [activo, setActivo] = useState({ name: "Activos", code: 1, });
    const [activos, setActivos] = useState([]);
    const [cliente, setCliente] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [servicios, setServicios] = useState([]);
    const [operadores, setOperadores] = useState({});
    const [actualizar, setActualizar] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [estructuras, setEstructuras] = useState(null);
    const [Inputs, setInputs] = useState({
        ID: "",
        NOMBRE: "",
        TIPO_SERVICIO: "",
        CHOFER: "",
        AUT_DIRECCION: "",
        ACTIVA: false,
        CLIENTE: "",
        WHATSAPP: "",
        CHOFER_SUB: null,
    })
    const [InputsAdd, setInputsAdd] = useState({
        ID: "",
        NOMBRE: "",
        TIPO_SERVICIO: "",
        CHOFER: "",
        AUT_DIRECCION: "",
        ACTIVA: false,
        CLIENTE: "",
        WHATSAPP: "",
        CHOFER_SUB: null,
    })
    // add
    const [visibleAdd, setVisibleAdd] = useState(false);
    useEffect(() => {
        const params = {
            activos: 1,
            cliente: cliente
        }
        getRutes(params, setData)
        getClients(setClientes)
        setActivos([
            {
                name: "Todos", code: -1,
            },
            {
                name: "Activos", code: 1,
            },
            {
                name: "Inactiva", code: 0,
            }
        ])
        getTipoServicios(setServicios)
        getAllOperadores(setOperadores)
    }, [])

    useEffect(() => {
        if (cliente) {
            const params = {
                activos: activo?.code,
                cliente: cliente?.code
            }
            getRutes(params, setData)
        }
    }, [cliente])
    useEffect(() => {
        if (activo) {
            const params = {
                activos: activo?.code,
                cliente: cliente?.code
            }
            getRutes(params, setData)
        }
    }, [activo])
    useEffect(() => {
        if (data) {
            const params = {
                activos: activo?.code,
                cliente: cliente?.code
            }
            getRutes(params, setData)
        }
    }, [actualizar])
    useEffect(() => {
        console.log("dataModal",dataModal);
        
        if (dataModal) {
            setVisible(true)
            let dataModalCopy = { ...dataModal }
            dataModalCopy.ID = dataModal.ID
            dataModalCopy.NOMBRE = dataModal.NOMBRE
            dataModalCopy.TIPO_SERVICIO = dataModal.TIPO_SERVICIO?JSON.parse(dataModal.TIPO_SERVICIO)[0]  : null
            dataModalCopy.CHOFER = dataModal.CHOFER?JSON.parse(dataModal.CHOFER)[0] : null
            dataModalCopy.AUT_DIRECCION = dataModal.AUT_DIRECCION
            dataModalCopy.ACTIVA = dataModal.ACTIVA
            dataModalCopy.CLIENTE = dataModal.CLIENTE?JSON.parse(dataModal.CLIENTE)[0] : null
            setInputs(dataModalCopy)
            // dataModalCopy.whatsapp=dataModal.,
            // dataModalCopy.chofer_sub=dataModal.,
        }
        else {
            setVisible(false)
        }
    }, [dataModal])
   

    const status = (rowData) => {
        return (
            <>
                {
                    rowData.ACTIVA ?
                        <>
                            <div className="Activa">Activa</div>
                        </>
                        :
                        <>
                            <div className="inhabil">Inactiva</div>
                        </>
                }
            </>
        )
    }

    const acciones = (rowData) => {
        return (
            <>

                <div className="edit" onClick={() => { setDataModal(rowData) }}>
                    <img src={lapiz} alt="" />
                </div>

            </>
        )
    }

    // Maneja el cambio dinámico en los campos
    const handleChange = async (e, name) => {
        // Extrae el nombre del campo y su valor
        let value
        if (name == "ACTIVA" || name == 'AUT_DIRECCION') { value = e.target.checked }
        else if (name == 'TIPO_SERVICIO' || name == 'CHOFER' || name == 'CLIENTE') { value = e.value }
        else { value = e.target.value }

        // Si se está desactivando la ruta, mostrar alerta de confirmación
        if (name === 'ACTIVA' && Inputs.ACTIVA === true && value === false) {
            // Aquí deberías hacer una llamada a tu API para obtener las estructuras y bitácoras
            // Por ahora simulo los datos
         const estructuras = await  getEstructuras(Inputs.ID)

            const estructurasAfectadas = estructuras ? estructuras.map(est => est.name) : [];
            const cantidadBitacoras = await getBitacorasAEliminar(Inputs.ID);

            const estructurasHTML = estructurasAfectadas.map(est => 
                `<li style="padding: 5px 0; font-size: 0.95em;">${est}</li>`
            ).join('');

            const result = await Swal.fire({
                title: '⚠️ Advertencia',
                html: `
                    <div style="text-align: left; padding: 15px 10px;">
                        <div style="background-color: #ffebee; padding: 15px; border-radius: 8px; border-left: 5px solid #d32f2f; margin-bottom: 20px;">
                            <h3 style="margin: 0 0 10px 0; color: #d32f2f; font-size: 1.1em;">
                                🚨 ADVERTENCIA CRÍTICA
                            </h3>
                            <p style="margin: 0; color: #c62828; font-weight: 500;">
                                Esta acción NO se puede revertir
                            </p>
                        </div>

                        <div style="margin-bottom: 20px;">
                            <h4 style="color: #333; margin: 0 0 12px 0; font-size: 1em; border-bottom: 2px solid #e0e0e0; padding-bottom: 8px;">
                                📋 Flujo de desactivación que se ejecutará:
                            </h4>
                            
                            <div style="background-color: #f5f5f5; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
                                <p style="margin: 0 0 10px 0; font-weight: 600; color: #555;">
                                    1️⃣ Estructuras a desactivar: <span style="color: #d32f2f; font-size: 1.1em;">${estructurasAfectadas.length}</span>
                                </p>
                                <ul style="margin: 5px 0 0 20px; color: #666; line-height: 1.6;">
                                    ${estructurasHTML}
                                </ul>
                            </div>

                            <div style="background-color: #f5f5f5; padding: 15px; border-radius: 8px;">
                                <p style="margin: 0; font-weight: 600; color: #555;">
                                    2️⃣ Bitácoras a eliminar: <span style="color: #d32f2f; font-size: 1.1em;">${cantidadBitacoras.servicios}</span>
                                </p>
                            </div>
                        </div>

                        <div style="background-color: #fff3cd; padding: 15px; border-radius: 8px; border-left: 5px solid #ffc107; margin-bottom: 20px;">
                            <h4 style="margin: 0 0 8px 0; color: #856404; font-size: 0.95em;">
                                🔄 Proceso de reactivación:
                            </h4>
                            <ol style="margin: 0; padding-left: 20px; color: #856404; font-size: 0.9em; line-height: 1.6;">
                                <li>Activar las rutas manualmente (modulo RUTAS)</li>
                                <li>Seleccionar estructuras a reactivar (modulo ESQUEMAS)</li>
                                <li>Programar nuevamente todos los servicios (modulo PROGRAMACIÓN)</li>
                            </ol>
                        </div>

                        <div style="background-color: #e3f2fd; padding: 12px; border-radius: 8px; border-left: 5px solid #2196f3;">
                            <p style="margin: 0 0 8px 0; font-weight: 600; color: #1565c0; font-size: 0.95em;">
                                ✍️ Para confirmar, escribe: <span style="color: #d32f2f;">desactivar</span>
                            </p>
                        </div>
                    </div>
                `,
                input: 'text',
                inputPlaceholder: 'Escribe "desactivar" para confirmar',
                inputAttributes: {
                    autocomplete: 'off',
                    autocorrect: 'off',
                    autocapitalize: 'off',
                    spellcheck: 'false'
                },
                didOpen: () => {
                    const input = Swal.getInput();
                    if (input) {
                        // Prevenir pegar con Ctrl+V o clic derecho
                        input.addEventListener('paste', (e) => {
                            e.preventDefault();
                            return false;
                        });
                        // Prevenir arrastrar y soltar texto
                        input.addEventListener('drop', (e) => {
                            e.preventDefault();
                            return false;
                        });
                        // Prevenir copiar y cortar
                        input.addEventListener('copy', (e) => {
                            e.preventDefault();
                            return false;
                        });
                        input.addEventListener('cut', (e) => {
                            e.preventDefault();
                            return false;
                        });
                    }
                },
                showCancelButton: true,
                confirmButtonColor: '#d32f2f',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Confirmar desactivación',
                cancelButtonText: 'Cancelar',
                width: '650px',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Debes escribir "desactivar" para confirmar';
                    }
                    if (value.toLowerCase() !== 'desactivar') {
                        return 'Debes escribir exactamente "desactivar"';
                    }
                },
                preConfirm: (value) => {
                    if (value.toLowerCase() !== 'desactivar') {
                        Swal.showValidationMessage('Debes escribir "desactivar" para confirmar');
                        return false;
                    }
                    return true;
                }
            });

            if (result.isConfirmed) {
                // El usuario confirmó, actualizar el estado
                setInputs((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            }
            // Si no confirmó, no hacemos nada (el checkbox se revierte solo)
        } else {
            // Para cualquier otro campo, actualizar normalmente
            setInputs((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };
    const handleChangeAdd = (e, name) => {
        // Extrae el nombre del campo y su valor
        let value
        if (name == "ACTIVA" || name == 'AUT_DIRECCION') { value = e.target.checked }
        else if (name == 'TIPO_SERVICIO' || name == 'CHOFER' || name == 'CLIENTE') { value = e.value }

        else { value = e.target.value }
        setInputsAdd((prevState) => ({
            ...prevState,
            [name]: value, // Actualiza solo el campo que cambió
        }));

    };
   
    const submit = () => {

        const id_tipo_servicio =  Inputs?.TIPO_SERVICIO?.code
        const id_chofer = Inputs?.CHOFER?.code
        const cliente =  Inputs?.CLIENTE?.code
        const params = {
            id:  Inputs?.ID,
            nombre: Inputs?.NOMBRE,
            id_tipo_servicio:id_tipo_servicio,
            id_chofer:id_chofer ,
            aut_direccion: Inputs?.AUT_DIRECCION?'1':'0',
            activa: Inputs?.ACTIVA?'1':'0',
            cliente: cliente

        }

        updateRuta(params,setVisible,setActualizar,actualizar)
    }
    const submitAdd = () => {

        const id_tipo_servicio =  InputsAdd.TIPO_SERVICIO.code
        const id_chofer = InputsAdd.CHOFER.code
        const cliente =  InputsAdd.CLIENTE.code
        const params = {
            id:  InputsAdd.ID,
            nombre: InputsAdd.NOMBRE,
            id_tipo_servicio:id_tipo_servicio,
            id_chofer:id_chofer ,
            aut_direccion: InputsAdd.AUT_DIRECCION?'1':'0',
            activa: InputsAdd.ACTIVA?'1':'0',
            cliente: cliente

        }

        addRuta(params,setVisibleAdd,setActualizar,actualizar)
    }
    return (
        <div className="Rutas">
            <TitleView title={"Rutas"}></TitleView>
            <GlovalCard>
                <div className="filtros">
                    <IconInput
                        type="search"
                        className='inputSize'
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Buscar..."
                        icon={searchIcon}
                    />
                    <InputLista obligatory={false} className={"inputSize"} placeholder={"Selecciona el cliente"} value={cliente} options={clientes} onChange={(e) => { setCliente(e.value) }} titulo={"Cliente"}></InputLista>
                    <InputLista obligatory={false} className={"inputSize"} placeholder={"Selecciona el estatus"} value={activo} options={activos} onChange={(e) => { setActivo(e.value) }} titulo={"Estatus"}></InputLista>
                    <Button width="100px" className={"botonNew"} onClick={()=> setVisibleAdd(true)}>Nueva</Button>
                </div>
                <DataTable
                    value={data}
                    globalFilter={globalFilter}
                    scrollable
                    scrollHeight="calc(100vh - 300px)"
                    rowGroupMode="subheader"
                    groupRowsBy="CLIENTE"
                    sortMode="single"
                    sortOrder={1}
                    rowGroupHeaderTemplate={(data) => {
                        const clienteName = data.CLIENTE ? JSON.parse(data.CLIENTE)[0].name : 'Sin Cliente';
                        return (
                            <div style={{ 
                                padding: '10px', 
                                fontWeight: 'bold', 
                                backgroundColor: '#f0f0f0', 
                                color: '#333',
                                position: 'sticky',
                                top: 0,
                                zIndex: 1
                            }}>
                                👤 {clienteName}
                            </div>
                        );
                    }}
                >
                    <Column sortable field="ID" header="Id" body={(rowData) => <td data-label="ID">{rowData?.ID}</td>} />
                    <Column sortable field="CLIENTE" header="Cliente" body={(rowData) => <td data-label="CLIENTE">{rowData.CLIENTE ? JSON.parse(rowData.CLIENTE)[0].name : null}</td>} />
                    <Column sortable field="NOMBRE" header="Nombre" body={(rowData) => <td className="nombre" data-label="NOMBRE">{rowData?.NOMBRE}</td>} />
                    <Column sortable field="TIPO_SERVICIO" header="Tipo de servicio" body={(rowData) => <td data-label="TIPO_SERVICIO">{rowData?.TIPO_SERVICIO ? JSON.parse(rowData?.TIPO_SERVICIO)[0]?.name : null}</td>} />
                    <Column sortable field="ACTIVA" header="Estatus" body={status} />
                    <Column  field="Acciones" header="Editar" body={acciones} />


                </DataTable>
            </GlovalCard>
            <Dialog header={() => { return (<><div className="headerModal">Editar ruta</div></>) }} visible={visible} style={{ width: '50vw' }} onHide={() => { if (!visible) return; setVisible(false); setDataModal(null) }} >
                <div className="containerInputs">
                    <div className="elemento">
                        <div className="col1">
                            <InputText className="inputFormRuta" title="ID" disabled={true} value={Inputs.ID}></InputText>
                            <InputText className="inputFormRuta" title="NOMBRE" value={Inputs.NOMBRE} onChange={(e) => handleChange(e, "NOMBRE")}></InputText>
                            <InputLista className="inputFormRuta" obligatory={false} titulo="TIPO SERVICIO" options={servicios} value={Inputs?.TIPO_SERVICIO} onChange={(e) => handleChange(e, "TIPO_SERVICIO")}></InputLista>
                            <InputLista className="inputFormRuta" obligatory={false} titulo="OPERADORES" options={operadores} value={Inputs?.CHOFER} onChange={(e) => handleChange(e, "CHOFER")}></InputLista>
                            <InputText className="inputFormRuta check" title="AUT DIRECCION" type="checkbox" checked={Inputs?.AUT_DIRECCION} value={Inputs?.AUT_DIRECCION} onChange={(e) => handleChange(e, "AUT_DIRECCION")}></InputText>
                            <InputText className="inputFormRuta check" title="ACTIVA" type="checkbox" checked={Inputs?.ACTIVA} value={Inputs?.ACTIVA} onChange={(e) => handleChange(e, "ACTIVA")}></InputText>
                            <InputLista className="inputFormRuta" obligatory={false} titulo="CLIENTE" options={clientes} value={Inputs?.CLIENTE} onChange={(e) => handleChange(e, "CLIENTE")}></InputLista>
                            {/* <InputText  className="inputFormRuta"title="WHATSAPP" value={Inputs.whatsapp} onChange={(e) => handleChange(e, "whatsapp")}></InputText> */}
                            {/* <InputText title="CHOFER SUB" value={Inputs.chofer_sub} onChange={(e) => handleChange(e, "chofer_sub")}></InputText> */}
                            <Button onClick={() => submit()} className={"BotonAceptar "}>Guardar</Button>
                        </div>

                    </div>
                </div>
            </Dialog>
            {/* agregat */}
            <Dialog header={() => { return (<><div className="headerModal">Nueva ruta</div></>) }} visible={visibleAdd} style={{ width: '50vw' }} onHide={() => { if (!visibleAdd) return; setVisibleAdd(false);}} >
                <div className="containerInputs">
                    <div className="elemento">
                        <div className="col1">
                            {/* <InputText className="inputFormRuta" title="ID" disabled={true} value={InputsAdd.ID}></InputText> */}
                            <InputText className="inputFormRuta" title="NOMBRE" value={InputsAdd.NOMBRE} onChange={(e) => handleChangeAdd(e, "NOMBRE")}></InputText>
                            <InputLista className="inputFormRuta" obligatory={false} titulo="TIPO SERVICIO" options={servicios} value={InputsAdd.TIPO_SERVICIO} onChange={(e) => handleChangeAdd(e, "TIPO_SERVICIO")}></InputLista>
                            <InputLista className="inputFormRuta" obligatory={false} titulo="OPERADORES" options={operadores} value={InputsAdd.CHOFER} onChange={(e) => handleChangeAdd(e, "CHOFER")}></InputLista>
                            <InputText className="inputFormRuta check" title="AUT DIRECCION" type="checkbox" checked={InputsAdd.AUT_DIRECCION} value={InputsAdd.AUT_DIRECCION} onChange={(e) => handleChangeAdd(e, "AUT_DIRECCION")}></InputText>
                            <InputText className="inputFormRuta check" title="ACTIVA" type="checkbox" checked={InputsAdd.ACTIVA} value={InputsAdd.ACTIVA} onChange={(e) => handleChangeAdd(e, "ACTIVA")}></InputText>
                            <InputLista className="inputFormRuta" obligatory={false} titulo="CLIENTE" options={clientes} value={InputsAdd.CLIENTE} onChange={(e) => handleChangeAdd(e, "CLIENTE")}></InputLista>
                            {/* <InputText  className="inputFormRuta"title="WHATSAPP" value={InputsAdd.whatsapp} onChange={(e) => handleChangeAdd(e, "whatsapp")}></InputText> */}
                            {/* <InputText title="CHOFER SUB" value={InputsAdd.chofer_sub} onChange={(e) => handleChangeAdd(e, "chofer_sub")}></InputText> */}
                            <Button onClick={() => submitAdd()} className={"BotonAceptar "}>Guardar</Button>
                        </div>

                    </div>
                </div>
            </Dialog>
        </div>
    )
}
export default Rutas